<template>
  <div :title="status_title + (version ? ` (v${version})` : '')" :class="`circle ${status_class}`"></div>
</template>

<script>
export default {
  props: ['status', 'version'],
  computed:{
    status_class(){
      switch (this.status) {
        case "DISCONNECTED":
          return 'red'
        
        case "IDLE":
          return 'green'
        
        case "BUSY":
          return 'orange'

        default:
          return 'grey lighten-2'
      }
    },
    status_title(){
      switch (this.status) {
        case "DISCONNECTED":
          return 'Отключен'
        
        case "IDLE":
          return 'Подключен'
        
        case "BUSY":
          return 'Выполняет задачи'

        default:
          return 'Нет данных'
      }
    }
  }
}
</script>

<style scoped>
.circle {
  margin: .1em;
  height: 1em;
  width: 1em;
  border-radius: 50%;
  box-shadow: 
      -.1em -.1em .5em 0 #00000011 inset, 
      .1em .1em .5em 0 #FFFFFF33 inset;

  transition: background-color .3s ease-in-out;
}
    
</style>